// モジュール画面のプレースホルダ工場（外枠）。中身（機能）は TMS 側で差し込む。
export function makePlaceholder(title, note, todos = []) {
  return function render(el) {
    el.innerHTML = `
      <section class="stub">
        <h2 class="stub__title">${title}<span class="tag">中身: TMS側で実装</span></h2>
        <p class="stub__note">${note}</p>
        <div class="stub__todo">この画面に載せる予定:
          <ul>${todos.map((t) => `<li>${t}</li>`).join('')}</ul>
        </div>
        <div class="placeholder-box"></div>
      </section>`
  }
}
